import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { from } from 'rxjs';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilitiesRoutingModule } from './utilities-routing.module';
import { CampaignsComponent } from './campaigns/campaigns.component';
import { AddCampaign } from './addcampaign/addcampaign.component';
import { UpsellingComponent } from './upselling/upselling.component';
import { AddaddupsellingComponent } from './addupselling/addupselling.component';
import { PromotionNotificationComponent } from './promotionnotification/promotionnotification.component';
import { AddPromotionComponent } from './addpromotion/addpromotion.component';
import { UserManagerComponent } from './usermanager/usermanager.component';
import { ScreenMappingComponent } from "./screenmapping/screenmapping.component";
import { BannersComponent } from './banners/banners.component';
import { AddBannerComponent } from "./addbanner/addbanner.component";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';


@NgModule({
    imports: [
        NgMultiSelectDropDownModule,
        CommonModule,
        NgbModule,
        AgGridModule.withComponents([]),
        UtilitiesRoutingModule,
        FormsModule,
        ReactiveFormsModule
    ],
    declarations: [
        CampaignsComponent,
        AddCampaign,
        UpsellingComponent,
        AddaddupsellingComponent,
        PromotionNotificationComponent,
        AddPromotionComponent,
        UserManagerComponent,
        ScreenMappingComponent,
        BannersComponent,
        AddBannerComponent
    ],
    providers: [],
    exports: [RouterModule]
})
export class UtilitiesModule {

}
